import parseISO from "date-fns/parseISO";
import { ajaxErrorPopUp } from "./alerts";

const getToken = async () => {
    if (!localStorage.getItem("jwt")) {
        await getNewToken();
    } else {
        if (localStorage.getItem("jwt_expires")) {

            // Let date-fns parse the UTC date into a local time and compare them..
            var expireDate = parseISO(localStorage.getItem("jwt_expires"));
            var now = new Date();

            if (expireDate <= now) {
                await getNewToken();
            }
        }
    }

    return localStorage.getItem("jwt");
}

const getNewToken = async () => {
    var tokenResp = await fetch("/api/security/gettoken");
    var t = await tokenResp.json();

    if (!tokenResp.ok) {
        console.error("Error getting token...");
        ajaxErrorPopUp(tokenResp.status, t.detail, t.title);
        return false;
    }

    localStorage.setItem("jwt", t.token);
    localStorage.setItem("jwt_expires", t.expires);
};

const authenticatedFetch = async (url, opts = {}) => {
    
    var token = await getToken();
    console.log("Token: " + token);

    const headers = Object.assign(opts.headers || {}, {
        "Authorization": `Bearer ${token}`
    });

    var optsWithHeader = Object.assign(opts, { headers });

    try {
        return fetch(url, optsWithHeader);
    } catch (e) {
        console.error("Error sending authenticated request:");
        console.error(e);
    }
};

export { authenticatedFetch, getToken };